import { TaxesComponent } from "@/features";

export const TaxesPage = () => {
  return <TaxesComponent />;
}